/**
 * AnchorNav content module.
 *
 * @module AnchorNav
 * @author EN GARDE
 * @version 1
 */

var EN = EN || {};

EN.AnchorNav = (function ($) {
	'use strict';

	var options = {
		selectors: {
			scroller: '.en-mdl-anchor_nav__items',
			item: '.en-mdl-anchor_nav__item',
			itemInner: '.en-mdl-anchor_nav__item-inner',
			anchor: '.en-anchor'
		},
		classNames: {
			active: 'en-is-active'
		},
		scrollSpeed: 500
	};
	var $items;
	var $itemsInner;

	/**
	 * Initialize module
	 * @memberof module:AnchorNav
	 * @return {undefined}
	 */
	var init = function (settings) {
		options = $.extend({}, options, settings);

		$items = $(options.selectors.item);
		$itemsInner = $(options.selectors.itemInner);

		$(document).on('viewenter.InView viewleave.InView', function (e) {
			var id = $(e.target).children(options.selectors.anchor).attr('id');
			var $target = $itemsInner.filter('[href="#' + id + '"]').closest($items);

			if (!$target.length) {
				return;
			}

			if (e.type === 'viewenter') {
				var $scroller = $target.closest(options.selectors.scroller);
				$target.addClass(options.classNames.active);
				$target.siblings($items).removeClass(options.classNames.active);

				// scroll to it
				var targetScroll = $target.offset().left;
				var parentWidth = $scroller.width();

				if (
					targetScroll + $target.width() > parentWidth + $scroller.scrollLeft() || // scroll right
					targetScroll + $target.width() < $scroller.scrollLeft() // scroll left
				) {
					$scroller.stop().animate({
						scrollLeft: targetScroll
					}, options.scrollSpeed);
				}
			}
			// else {
			// 	$target.removeClass(options.classNames.active);
			// }
		});

		// smooth scroll
		$itemsInner.on('click', function (e) {
			var id = $(this).attr('href');
			var $target = $(id);

			if ($target.length) {
				e.preventDefault();

				$('body, html').animate({
					scrollTop: $target.offset().top
				}, options.scrollSpeed, function () {
					window.location.hash = id;
				});
			}
		});
	};

	// exports
	return {
		init: init
	};
}(jQuery));
